import { Link } from 'react-router-dom';
import { useLangHref, useT } from '@/lib/useLang';

export function NotFound() {
  const t = useT();
  const withLang = useLangHref();

  return (
    <section className="nz-page nz-page--center">
      <h1 className="nz-page__title">{t.notFoundTitle}</h1>
      <p className="nz-lead">{t.notFoundBody}</p>
      <p>
        <Link className="nz-btn-primary" to={withLang('/')}>
          {t.notFoundBack}
        </Link>
      </p>
    </section>
  );
}
